/* ==========================================================================
   ALBEUX FUTURE MOTION (assets/albeux-future-motion.js)
   One self-contained script. Nothing else in the theme was rewritten.
   It does five quiet things, all with transform and opacity only:
   1. Headlines reveal line by line (home, collection, collections list, content pages, and the Enduring Silhouette statement).
   2. A gentle fade-up as the statement, trust badge, reviews and page text scroll into view.
   3. A soft light follows the mouse over product photos (the second photo on hover is the theme's own setting).
   4. Buttons lean very slightly toward the mouse (mouse screens only).
   5. Nothing runs for people who ask their device for reduced motion, and nothing changes any font, size or text style.
   To remove: delete the four ALBEUX FUTURE lines in layout/theme.liquid (the script and both stylesheets), then delete the three albeux-future files.
   ========================================================================== */
(function () {
  if (window.__albeuxFutureMotion) return;
  window.__albeuxFutureMotion = true;
  var doc = document.documentElement;
  function mq(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  if (mq('(prefers-reduced-motion: reduce)')) { doc.classList.add('alb-fx-ready'); return; }
  var fine = mq('(hover: hover) and (pointer: fine)');
  var hasIO = 'IntersectionObserver' in window;
  var heads = [];
  var TEMPLATES = /^(index|collection|list-collections|page|blog|article)/;
  var SKIP = '.acine, dialog, [role="dialog"], details, facets-form, .facets, .card-gallery, product-card, [data-no-reveal]';
  var FADE = '.albeux-statement__text, .albeux-trust, .albeux-reviews, main[data-template^="page"] .rte > *, [data-alb-fade]';

  function qa(s) { try { return [].slice.call(document.querySelectorAll(s)); } catch (e) { return []; } }

  /* 1. Headline: one line at a time ------------------------------------- */
  var hio = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); hio.unobserve(e.target); }
    });
  }, { threshold: 0.2, rootMargin: '0px 0px -4% 0px' }) : null;

  function collectHeads() {
    var list = qa('.albeux-statement__title');
    var m = document.getElementById('MainContent');
    var t = (m && m.getAttribute('data-template')) || '';
    if (TEMPLATES.test(t)) list = list.concat(qa('#MainContent h1, #MainContent h2'));
    return list;
  }

  function eligible(h) {
    if (h.__alb || h.children.length || h.closest(SKIP)) return false;
    var text = (h.textContent || '').replace(/[ \t\r\n]+/g, ' ').trim();
    if (!text || text.length > 160) return false;
    var r = h.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    h.__alb = { text: text, w: 0 };
    return true;
  }

  /* Measure where the browser breaks the lines, then wrap each line in its own mask */
  function lineify(h) {
    var st = h.__alb;
    if (!st) return;
    h.textContent = '';
    var spans = [];
    st.text.split(' ').forEach(function (w, i) {
      if (i) h.appendChild(document.createTextNode(' '));
      var s = document.createElement('span');
      s.textContent = w;
      s.style.display = 'inline-block';
      h.appendChild(s);
      spans.push(s);
    });
    var lines = [];
    var top = null;
    var cur = null;
    spans.forEach(function (s) {
      var t = s.offsetTop;
      if (top === null || Math.abs(t - top) > 4) { cur = []; lines.push(cur); top = t; }
      cur.push(s.textContent);
    });
    h.textContent = '';
    lines.forEach(function (words, i) {
      var outer = document.createElement('span');
      outer.className = 'alb-line';
      outer.setAttribute('aria-hidden', 'true');
      var inner = document.createElement('span');
      inner.className = 'alb-line__in';
      inner.style.setProperty('--l', i);
      inner.textContent = words.join(' ');
      outer.appendChild(inner);
      h.appendChild(outer);
    });
    st.w = Math.round(h.getBoundingClientRect().width);
  }

  var rt = 0;
  function relayout(force) {
    heads.forEach(function (h) {
      if (!h.isConnected) return;
      var w = Math.round(h.getBoundingClientRect().width);
      if (force || Math.abs(w - h.__alb.w) > 2) lineify(h);
    });
  }

  /* 2. Fade-up: only things that are still below the screen are hidden, so nothing ever flashes ---------- */
  var fio = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('alb-in'); fio.unobserve(e.target); }
    });
  }, { threshold: 0.01, rootMargin: '0px 0px -8% 0px' }) : null;

  function fade() {
    if (!fio) return;
    qa(FADE).forEach(function (el) {
      if (el.__altf) return;
      el.__altf = 1;
      if (el.closest('[data-zoom], .acine, dialog')) return;
      var r = el.getBoundingClientRect();
      if (r.bottom <= 0 || r.top < window.innerHeight * 0.9) return;
      el.classList.add('alb-fade');
      fio.observe(el);
    });
  }

  function init() {
    var fresh = collectHeads().filter(eligible);
    fresh.forEach(function (h) {
      heads.push(h);
      lineify(h);
      h.classList.add('alb-split');
      h.setAttribute('aria-label', h.__alb.text);
      if (hio) hio.observe(h); else h.classList.add('is-in');
    });
    doc.classList.add('alb-fx-ready');
    fade();
  }

  var fontsReady = (document.fonts && document.fonts.ready)
    ? Promise.race([document.fonts.ready, new Promise(function (r) { setTimeout(r, 1400); })])
    : Promise.resolve();
  fontsReady.then(init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { relayout(false); }, 250);
  }, { passive: true });
  if (document.fonts && document.fonts.addEventListener) {
    document.fonts.addEventListener('loadingdone', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { relayout(true); }, 60);
    });
  }

  if (!fine) return;

  /* 3. Soft light that follows the mouse over product photos ---------------- */
  var gRaf = 0;
  var gLast = null;
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var t = e.target && e.target.closest ? e.target.closest('.product-grid__item .card-gallery, .resource-list__item .card-gallery') : null;
    if (!t) return;
    if (!t.__glow) {
      var g = document.createElement('span');
      g.className = 'alb-glow';
      g.setAttribute('aria-hidden', 'true');
      t.appendChild(g);
      t.__glow = g;
    }
    gLast = { t: t, x: e.clientX, y: e.clientY };
    if (gRaf) return;
    gRaf = requestAnimationFrame(function () {
      gRaf = 0;
      var r = gLast.t.getBoundingClientRect();
      if (!r.width || !r.height) return;
      gLast.t.style.setProperty('--alb-gx', (((gLast.x - r.left) / r.width) * 100).toFixed(1) + '%');
      gLast.t.style.setProperty('--alb-gy', (((gLast.y - r.top) / r.height) * 100).toFixed(1) + '%');
    });
  }, { passive: true });

  /* 4. Magnetic buttons: a lean of at most 6px sideways and 4px up or down ---------- */
  var mag = null;
  function release() {
    if (!mag) return;
    var el = mag;
    mag = null;
    var from = el.style.transform || 'translate3d(0,0,0)';
    el.style.transform = '';
    if (el.animate) el.animate([{ transform: from }, { transform: 'translate3d(0,0,0)' }], { duration: 450, easing: 'cubic-bezier(.22,.61,.36,1)' });
  }
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var el = e.target && e.target.closest ? e.target.closest('a.button, button.button, .acine__button') : null;
    if (!el || el.closest('main[data-template^="product"], product-form-component, dialog, [data-no-magnet]')) { release(); return; }
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return;
    mag = el;
    var dx = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (r.width / 2)));
    var dy = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height / 2)));
    el.style.transform = 'translate3d(' + (dx * 6).toFixed(1) + 'px,' + (dy * 4).toFixed(1) + 'px,0)';
  }, { passive: true });
  document.addEventListener('pointerout', function (e) {
    if (mag && !mag.contains(e.relatedTarget)) release();
  }, { passive: true });
})();